// extracted by mini-css-extract-plugin
export var border = "_j-7";
export var brand = "_j-r";
export var button = "_j-j";
export var center = "_j-9";
export var centered = "_j-5";
export var closeButton = "_j-b";
export var disabledWrapper = "_j-k";
export var error = "_j-n";
export var extraLarge = "_j-4";
export var extraSmall = "_j-1";
export var fill = "_j-g";
export var footer = "_j-f";
export var footerAction = "_j-h";
export var footerButtons = "_j-i";
export var header = "_j-6";
export var icon = "_j-m";
export var info = "_j-q";
export var inline = "_j-8";
export var large = "_j-3";
export var main = "_j-c";
export var modal = "_j-0";
export var neutral = "_j-s";
export var noPadding = "_j-e";
export var none = "_j-t";
export var scrollable = "_j-d";
export var small = "_j-2";
export var success = "_j-p";
export var tight = "_j-l";
export var titleIcon = "_j-a";
export var warn = "_j-o";